import { setCarisState } from './state';
import * as mutations from './mutations';
import * as actions from './actions';

export default (placeholder) => ({
  state: setCarisState(placeholder),
  mutations,
  actions,
  namespaced: true,
});
